{
    "per_month": "month",
    "per_quarter": "quarter",
    "per_year": "year"
}
